import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAo47Vyk1wZjSq-4NDO6J60AO3CDDhbRxQ",
  authDomain: "acefund-website.firebaseapp.com",
  projectId: "acefund-website",
  storageBucket: "acefund-website.firebasestorage.app",
  messagingSenderId: "27965763116",
  appId: "1:27965763116:web:c439f83f2303a738956b89",
  measurementId: "G-9H65WB2J3K",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
